define('controller/people/internal.associations.detail.controller',['require','exports','module','fukit/fukit','model/association.model','view/people/internal.associations.page.view','model/person.model','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseController                = require('fukit/fukit').BaseController,
      AssociationsModel             = require('model/association.model'),
      InternalAssociationDetailView = require('view/people/internal.associations.page.view'),
      PersonModel                   = require('model/person.model'),
      ROLES                         = require('fukit/fukit').Roles;

  // var ANY_UNIT_ROLE = [ROLES.UNIT_CREATE, ROLES.UNIT_READ, ROLES.UNIT_UPDATE, ROLES.UNIT_DELETE];

  var PeopleInternalAssociationsDetailController = BaseController.extend({
    radioRequests: {
      'controllers PeopleInternalAssociationsDetailController': '@constructor',
    },

    pageView: InternalAssociationDetailView,

    // stateConfiguration: {
    //   defaults: {
    //     roles: ROLES.GLOBALACCESSROLES
    //   }
    // },

    resources: {
      person: {
        fetchOnStart: true,
        model: PersonModel,
        attrs: {
          id: '@state.primaryId',
        },
      },
      association: {
        fetchOnStart: true,
        model: AssociationsModel,
        attrs: {
          id: '@state.id',
        },
      },
    },

    onStart: function() {
      this.getResource('association').urlParams({ personId: this.state.get('primaryId') });
    },
  });

  module.exports = PeopleInternalAssociationsDetailController;
});

